import React, { Fragment } from "react";
import clsx from "clsx";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Paper, Grid, Typography, Divider } from "@material-ui/core";
import {
  AllUserIcon,
  AllProjectIcon,
  InProcessIcon,
  CompleteIcon,
} from "../material/icons";

export interface IWidgetData {
  icon: "allUser" | "allProject" | "inProcess" | "complete";
  label: String;
  value: Number | String;
}

interface IWidgetSummary {
  data: IWidgetData[];
  select?: Boolean;
  selectable?: Boolean;
}

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    padding: `${theme.spacing(2) - 4}px 0px`,
  },
  selected: { border: `1px solid ${theme.palette.primary.main}` },
  pointer: { cursor: "pointer" },
  middle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: { width: theme.spacing(8), height: theme.spacing(8) },
  valueText: { fontFamily: "Montserrat-SemiBold" },
  textCenter: { textAlign: "center" },
  hasDivider: { maxWidth: `calc(16.666667% - 1px)` },
  divider: { height: theme.spacing(8), width: 1 },
  topicIcon: { color: theme.palette.primary.main },
}));

const WidgetSummary = (props: IWidgetSummary) => {
  const classes = useStyle();
  const { data, select, selectable } = props;
  return (
    <Paper
      elevation={1}
      className={clsx(
        classes.root,
        select && classes.selected,
        selectable && classes.pointer
      )}
    >
      <Grid container direction="row">
        {data.map((d: IWidgetData, i: number) => (
          <Fragment key={d.icon}>
            <Grid item xs={data.length > 1 ? 2 : 6} className={classes.middle}>
              {d.icon === "allUser" ? (
                <AllUserIcon
                  className={clsx(classes.icon, classes.topicIcon)}
                />
              ) : d.icon === "allProject" ? (
                <AllProjectIcon
                  className={clsx(classes.icon, classes.topicIcon)}
                />
              ) : d.icon === "inProcess" ? (
                <InProcessIcon
                  className={clsx(classes.icon, classes.topicIcon)}
                />
              ) : d.icon === "complete" ? (
                <CompleteIcon
                  className={clsx(classes.icon, classes.topicIcon)}
                />
              ) : null}
            </Grid>
            <Grid
              item
              xs={data.length > 1 ? 2 : 6}
              className={clsx(
                classes.middle,
                i !== data.length - 1 && data.length > 1 && classes.hasDivider
              )}
            >
              <div>
                <Typography
                  variant="h5"
                  color="primary"
                  className={clsx(classes.textCenter, classes.valueText)}
                >
                  {d.value}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  className={classes.textCenter}
                >
                  {d.label}
                </Typography>
              </div>
            </Grid>
            {i !== data.length - 1 && data.length > 1 && (
              <Divider className={classes.divider} />
            )}
          </Fragment>
        ))}
      </Grid>
    </Paper>
  );
};

export default WidgetSummary;
